import { render, staticRenderFns } from "./drawlots.vue?vue&type=template&id=2bfd2617&scoped=true&"
import script from "./drawlots.vue?vue&type=script&lang=js&"
export * from "./drawlots.vue?vue&type=script&lang=js&"
import style0 from "./drawlots.vue?vue&type=style&index=0&id=2bfd2617&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bfd2617",
  null
  
)

export default component.exports